module.exports = {"350626100":"西埔镇","350626101":"樟塘镇","350626102":"康美镇","350626103":"杏陈镇","350626104":"陈城镇","350626105":"前楼镇","350626106":"铜陵镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350626.json
// module id = 1327
// module chunks = 0